export const OnboardRegistrationRoutesURLs = {
  home: "/",
  onboard: "/onboard-registration/",
  onboardVerifyEmail: "/onboard-registration/verify-email",
  onboardContactInfo: "/onboard-registration/contact-info",
  onboardSkills: "/onboard-registration/skills",
  forgotPassword: "/onboard-registration/forgot-password"
};
